/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnaireAnswer } from './QuestionnaireAnswer';
import {
  QuestionnaireAnswerFromJSON,
  QuestionnaireAnswerFromJSONTyped,
  QuestionnaireAnswerToJSON,
} from './QuestionnaireAnswer';

/**
 *
 * @export
 * @interface PaginatedQuestionnaireAnswerList
 */
export interface PaginatedQuestionnaireAnswerList {
  /**
   *
   * @type {number}
   * @memberof PaginatedQuestionnaireAnswerList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedQuestionnaireAnswerList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedQuestionnaireAnswerList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<QuestionnaireAnswer>}
   * @memberof PaginatedQuestionnaireAnswerList
   */
  results: Array<QuestionnaireAnswer>;
}

/**
 * Check if a given object implements the PaginatedQuestionnaireAnswerList interface.
 */
export function instanceOfPaginatedQuestionnaireAnswerList(value: object): value is PaginatedQuestionnaireAnswerList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedQuestionnaireAnswerListFromJSON(json: any): PaginatedQuestionnaireAnswerList {
  return PaginatedQuestionnaireAnswerListFromJSONTyped(json, false);
}

export function PaginatedQuestionnaireAnswerListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedQuestionnaireAnswerList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(QuestionnaireAnswerFromJSON),
  };
}

export function PaginatedQuestionnaireAnswerListToJSON(value?: PaginatedQuestionnaireAnswerList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(QuestionnaireAnswerToJSON),
  };
}
